module.exports = __webpack_public_path__ + "img/album17_09.29a068f4.jpg";